import Moment from 'react-moment';
import { useDispatch, useSelector } from "react-redux";
import { getSignImage } from "../../slices/sign_image";
import React, { useState, useEffect,useMemo } from 'react';

const NiceSignImage = (props) => {

const imageID = props.children
const signImage = useSelector((state) => state.signImage.data.list.find(image => image.id === imageID));  

const dispatch = useDispatch();

useEffect(() => {

  if (!signImage && imageID > 0){
    dispatch(getSignImage(imageID));
  }

}, [signImage]);


if (imageID <= 0) {

  return "Default Image"
}

return (
    
  signImage?.name

)
}


export default NiceSignImage;